"use client"
import DramaList from '../component/DramaList';
import watch from "../watchnow/watch.module.css";
import { EpisodeProgress, useWatchProgressStore } from '../store/localapi';
import { useMemo } from 'react';
import InFeedAd from '../component/ad/InFeedAd';


export default function Continuewatch() {
  const progress = useWatchProgressStore((s) => s.progress);
  const watchedHistory: EpisodeProgress[] = useMemo(() => {
    return Object.values(progress).sort((a, b) => (b.watchedOn || 0) - (a.watchedOn || 0));
  }, [progress]);
  // eslint-disable-next-line
  const data: any = watchedHistory.map((e: EpisodeProgress) => ({
    ...e,
    d_name: e.d_title,
    total_d_stream: e.total_ep
  }));



  return (
    <>
      <div className={watch.watchNow}>
        <h2>Continue Watching</h2>
      </div>
      <div className={watch.watchDramasBg}>
        <div className="container">
          {/* In-Feed Ad */}
          <InFeedAd style={{ margin: '20px 0' }} />
          
          <DramaList dramas={data} allEp={false} />
        </div>
      </div>
    </>
  )
}
